
import ClickOutside from "vue-click-outside";
import { mapState } from "vuex";
import { pathOr } from "ramda";

export default {
  directives: { ClickOutside },

  props: {
    tiles: { type: Array, default: () => [] },
    selectedTile: { type: String, default: "" },
    isSingleSizeSelected: { type: Boolean, default: false },
    label: { type: String, default: "" },
  },

  data() {
    return { internalSelectedTile: this.selectedTile, infoDialog: false };
  },

  computed: {
    ...mapState("pdp", ["variantLoading"]),
    ...mapState({
      order: s => s.siteConfig.pdp.comfortFeelOrder,
      mattressLabel: s => s.siteConfig.pdp.mattressFeelLabel,
    }),
    labelText() {
      return this.isSingleSizeSelected
        ? "Mattress Feel"
        : pathOr("", [this.label], this.mattressLabel);
    },
    sortedTiles() {
      const { order } = this;
      return this.tiles
        .slice()
        .sort(
          (a, b) => order.indexOf(a.tileLabel) - order.indexOf(b.tileLabel)
        );
    },
    sisAttributeName() {
      return "data-sis-" + this.labelText.replace(/\s+/g, "-")?.toLowerCase();
    },
  },

  watch: {
    selectedTile(value) {
      this.internalSelectedTile = value;
    },
  },

  methods: {
    handleClick(targetVariantId, tileLabel) {
      this.internalSelectedTile = tileLabel;
      this.$emit("select-variant-id", targetVariantId);
    },
    closeModal() {
      this.infoDialog = false;
    },
  },
};
